import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [],
    imports: [
        CommonModule, RouterModule.forChild([
            {
                path: 'byod-summary',
                loadChildren: './byod-summary/byod-summary.module#ByodSummaryModule'
            },
            {
                path: 'multi-order-history',
                loadChildren: './multi-order-history/multi-order-history.module#MultiOrderHistoryModule'
            },
            {
                path: 'multi-order-detail',
                loadChildren: './multi-order-detail/multi-order-detail.module#MultiOrderDetailModule'
            },
            {
                // TODO: should this be child route?
                path: 'order-detail',
                loadChildren: './order-detail/order-detail.module#OrderDetailModule'
            }, {
                path: 'order-status',
                loadChildren: './order-status/order-status.module#OrderStatusModule'
            }, {
                path: 'saved-order-list',
                loadChildren: './saved-order-list/saved-order-list.module#SavedOrderListModule'
            }, {
                path: 'summary-list',
                loadChildren: './summary-list/summary-list.module#SummaryListModule'
            },
        ])
    ]
})
export class SummaryModule {
}
